import React from 'react';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import { Divider } from 'components/common/Divider/Divider';
import { ValuationSlider } from 'components/WebOfferPage/EquitySection/ValuationSlider/ValuationSlider';

import './equity-section.scss';

// The current valuation of the company in billions of USD;
// TODO: Get this from the backend.
const CURRENT_VALUATION_USD_BILLIONS = 15;

export function EquitySection(): JSX.Element {
  return (
    <Flex
      className="equity-section-container"
      direction="column"
      gap="xl"
      alignment="center"
      justify="center"
      padding="xxl"
    >
      <div id="equity">
        <Flex className="equity-section" direction="column" gap="md">
          <Flex className="equity-section-header" direction="column">
            <Typography variant="title">EQUITY</Typography>
            <Typography variant="header">
              Understanding the potential value of your equity
              <a className="text-style-link" href="#disclaimer">
                *
              </a>
            </Typography>
          </Flex>
          <ValuationSlider currentValuation={CURRENT_VALUATION_USD_BILLIONS} />
          <div id="disclaimer">
            <Flex className="equity-dislaimer" direction="column" gap="md">
              <Divider orientation="horizontal" />
              <Typography variant="subtitle">
                Important Equity Information & Legal Advisory
              </Typography>
              <Typography variant="caption">
                Equity in private companies is difficult to value, and the values expressed here are
                based on assumptions and hypothetical scenarios about the current and potential
                future value of the company’s equity. None of the values herein should be
                interpreted by you as an express or implied promise, representation or warranty of
                the past, present or future value of Applied Intuition&apos;s equity or the value
                that you could or would receive for your restricted stock units (&quot;RSUs&quot;)
                or any other equity in the company you may receive.
              </Typography>
              <Typography variant="caption">
                The sliding scale above is intended as an example of potential outcomes at
                hypothetical future investor valuations to give you a feel for the offer. The
                calculation of potential value in this sliding scale assumes “fully diluted” total
                shares outstanding on an as-converted to common stock basis as of November 1, 2025.
                These hypothetical scenarios do not account for future dilution, stock splits, taxes
                or any other transactions, costs or fees.
              </Typography>
              <Typography variant="caption">
                RSUs at Applied Intuition are generally “double-trigger” RSUs, meaning that they are
                subject to both a time-vesting requirement and the occurrence of a liquidity event
                (like an IPO or sale of the company) to fully vest and settle. New hire RSUs
                generally time-vest as follows: 25% of the RSUs time-vest on the one-year
                anniversary of the first vesting date after an employee’s start date and the
                remaining RSUs time-vest in equal quarterly installments over the next 12 vesting
                dates. The company’s vesting dates are generally February 20, May 20, August 20, and
                November 20 of each year. Note that time-vesting of any RSUs will stop upon
                termination of your employment.
              </Typography>
              <Typography variant="caption">
                While the Company may grant you a larger RSU in connection with a lower cash salary
                or bonus, it is important to understand that the two are not necessarily of
                comparable value. Annual equity values are approximate based on the total notional
                value of such RSUs divided by four years.
              </Typography>
              <Typography variant="caption">
                All information here is informational only and the terms of your employment offer is
                subject to your final offer letter, which you should review closely in its entirety.
              </Typography>
            </Flex>
          </div>
        </Flex>
      </div>
    </Flex>
  );
}
